module.exports = __webpack_public_path__ + "static/entete-image-offre-c193c5a774ad127ac471bcca81aec0ac.jpg";